import { useQuery } from "@tanstack/react-query";
import { CertificationFamilyDictionaryModel, certificationFamilyDictionaryService } from "../../services/dictionaries";

export const useCertificationFamiliesDictionary = () => {
    return useQuery({
        queryKey: ["certification-families", "dictionary"],
        queryFn: (): Promise<CertificationFamilyDictionaryModel[]> =>
            certificationFamilyDictionaryService.getCertificationFamilies(),
        staleTime: 1000 * 60 * 15, // 15 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
    });
};
